import ReactDOM from 'react-dom/client'
import { ThemeProvider } from 'styled-components'
import { light, ResetCSS } from '@pancakeswap/uikit'
import { Provider } from 'react-redux'
import { HashRouter, BrowserRouter } from "react-router-dom"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import 'antd/dist/antd.css'
import store from './store'
import Routes from './router'
import './app.css'
import './styles/style.css'
import { AppProvider } from './context'
import { ProviderProvider } from '@/context/ProviderContext'
import { WalletInfoProvider } from '@/context/WalletInfoContext'
import { WagmiProvider } from 'wagmi'
import { wagmiConfig } from '@/utils/wagmi'
import { RainbowKitProvider, lightTheme, Theme } from '@rainbow-me/rainbowkit';
import merge from 'lodash.merge'; // 建议用 lodash.merge 来扩展基础主题
const queryClient = new QueryClient()
const myCustomTheme = merge(lightTheme(), {
  colors: {
    accentColor: '#1fc7d4', // 修改成你想要的任何颜色，例如绿色
  },
} as Theme);
ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <AppProvider>
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <ProviderProvider>
          <WalletInfoProvider>
            {/* <PersistGate loading={null} persistor={persistor}> */}
            <WagmiProvider config={wagmiConfig}>
              <RainbowKitProvider theme={myCustomTheme}>
                <HashRouter >
                  <ThemeProvider theme={light}>
                    <ResetCSS />
                    <Routes />
                  </ThemeProvider>
                </HashRouter>
              </RainbowKitProvider>
            </WagmiProvider>
          </WalletInfoProvider>
        </ProviderProvider>

      </Provider>
    </QueryClientProvider>
  </AppProvider >
)
